const errorCodesConstants = Object.freeze({
  WEBSOCKET: 101,
  SERVER: 102
});

export {
  errorCodesConstants
};

